import axios from "axios";
import { JWT_TOKEN } from "../../const";

import router from "../../router";
import store from "../../store";
import Qs from "qs";
import Vue from "vue";

const API_URL = process.env.API_URL;
const COCO_API_URL = process.env.COCO_API_URL;

export const httpLoginClient = axios.create({
  baseURL: API_URL,
  withCredentials: false,
});

export const httpClient = axios.create({
  baseURL: API_URL,
  withCredentials: false,
  paramsSerializer: (params) => Qs.stringify(params, { arrayFormat: "repeat" }),
});

export const cocoHttpClient = axios.create({
  baseURL: COCO_API_URL,
  withCredentials: false,
  paramsSerializer: (params) => Qs.stringify(params, { arrayFormat: "repeat" }),
});

export const uploadClient = axios.create({
  baseURL: COCO_API_URL,
  withCredentials: false,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

uploadClient.interceptors.request.use((config) => {
  config.headers = {
    Authorization: `Bearer ${localStorage.getItem(JWT_TOKEN)}`,
  };
  return config;
});

uploadClient.interceptors.response.use(undefined, async function (error) {
  store.state.common.isLoading = false;
  Vue.$toast.clear();
  Vue.$toast.error("서비스 처리중 오류가 발생했습니다.");
  return Promise.reject(error);
});

export const downloadClient = axios.create({
  baseURL: API_URL,
  withCredentials: false,
  responseType: "blob",
});

downloadClient.interceptors.request.use((config) => {
  config.headers = {
    Authorization: `Bearer ${localStorage.getItem(JWT_TOKEN)}`,
  };
  return config;
});

export const httpClientOnlyRefresh = axios.create({
  baseURL: API_URL,
  withCredentials: false,
  timeout: 3000,
  headers: {},
});

export const excelHttpClient = axios.create({
  baseURL: API_URL,
  withCredentials: false,
  responseType: "blob",
  // paramsSerializer: params => Qs.stringify(params, { arrayFormat: 'repeat' })
});

httpClient.interceptors.request.use((config) => {
  config.headers = {
    Authorization: `Bearer ${localStorage.getItem(JWT_TOKEN)}`,
  };
  return config;
});

cocoHttpClient.interceptors.request.use((config) => {
  config.headers = {
    Authorization: `Bearer ${localStorage.getItem(JWT_TOKEN)}`,
  };
  return config;
});

httpClient.interceptors.request.use((config) => {
  config.headers = {
    Authorization: `Bearer ${localStorage.getItem(JWT_TOKEN)}`,
  };
  return config;
});

excelHttpClient.interceptors.request.use((config) => {
  config.headers = {
    Authorization: `Bearer ${localStorage.getItem(JWT_TOKEN)}`,
  };
  return config;
});

httpClient.interceptors.response.use(undefined, async function (error) {
  store.state.common.isLoading = false;
  const res = error.response ? error.response : null;

  if (res.status === 401) {
    router.push({ path: `/login` });
    return Promise.reject(error);
  } else {
    Vue.$toast.clear();
    if (!res) {
      Vue.$toast.error(
        "서비스 처리중 오류가 발생했습니다." + res.message ? res.message : ""
      );
      return;
    }
    if (res.data.message) {
      Vue.$toast.error(res.data.message);
    } else {
      Vue.$toast.error(
        "서비스 처리중 오류가 발생했습니다." + res.message ? res.message : ""
      );
    }
  }
  return Promise.reject(error);
});
